import React, { FC, Fragment, useState } from "react";
import triangle from "../../assets/triangle.svg";
import "./Tooltip.scss";

interface ITooltip {
  tooltipTitle?: string;
  tooltipDescription: string;
  leftPositioning: number;
  icon?: string;
  showTooltip?: boolean;
  isPercentage?: boolean;
  removeTriangleIcon?: boolean;
}

const Tooltip: FC<ITooltip> = ({
  tooltipTitle,
  tooltipDescription,
  leftPositioning,
  icon,
  showTooltip,
  isPercentage,
  removeTriangleIcon,
}) => {
  const [isTooltipVisible, toggleIsTooltipVisible] = useState(false);
  return (
    <Fragment>
      {icon && (
        <img
          src={icon}
          alt="link"
          onMouseEnter={() => toggleIsTooltipVisible(true)}
          onMouseLeave={() => toggleIsTooltipVisible(false)}
        />
      )}
      <div
        className={`tooltip ${
          (isTooltipVisible || showTooltip) && "tooltip--visible"
        }`}
        style={{
          left: `${leftPositioning}${isPercentage ? "%" : "em"}`,
        }}
      >
        <div className="tooltip__content">
          <p className="tooltip__title">{tooltipTitle}</p>
          <p className="tooltip__description">{tooltipDescription}</p>
        </div>
        {!removeTriangleIcon && <img src={triangle} alt="triangle_icon" />}
      </div>
    </Fragment>
  );
};

export default Tooltip;
